module.exports = __webpack_public_path__ + "h5/img/live-logo.e8a0fbc1.gif";